import type {FooterLeftActionProps} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-left-actions/ai-prompt-box-footer-left-actions.types';

export type AiPromptBoxBrandKitSelectorProps = FooterLeftActionProps;

export const BRAND_KIT_SELECTOR_MODAL_PANEL_ID = 'ai-prompt-box-brand-kit-selector-modal-panel';
